import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.css']
})
export class DropdownComponent implements OnInit {
  @Input() fieldCtrl: FormControl;
  @Input() dropdownList: Array<string>
  @Input() isDisabled: boolean = false;
  @Output() valueSelected = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
    console.log('isDisabled: 11', this.isDisabled);
  }

  onChange($event){
    console.log('$event: ', $event)
    this.valueSelected.emit($event)
  }

}
